import React from 'react'
import usePost from 'hooks/usePost';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import CustomBtn from 'components/ui/CustomBtn';
import { Col, Row } from 'reactstrap';
import { loginUser } from 'Redux/Slices/userSlice';
import { useStore1Selector } from 'index';

function MandateModal({ loanId, onClose, reFetch }) {

    const userDet = useStore1Selector(loginUser);

    const token = userDet?.token;
    const { execute, pending, data } = usePost()

    const handleValidSubmit = (e, values) => {
        e.preventDefault();
        const Method = 'POST', endPoint = `mandates`;

        const raw = JSON.stringify({
            gracePeriodPercentage: values.gracePeriodPercentage,
            gracePeriodPaymentDate: values.gracePeriodPaymentDate,
            gracePeriodAmount: values.gracePeriodAmount,
            user: userDet?.data?.data?._id,
            loan: loanId
        });

        execute(endPoint, raw, Method, "Successfully Sent", token)
    }

    if (data?.status === 'success') {
        onClose();
        setTimeout(() => {
            reFetch()
        }, 2000)
    }

    return (
        <div>
            <Row>
                <AvForm className="form-horizontal mt-4" onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
                    <Row>
                        <Col sm={12} md={6}>
                            <div className="mb-3">
                                <AvField
                                    name="gracePeriodPercentage"
                                    label="Grace Period Percentage"
                                    className="form-control"
                                    placeholder="Enter percentage"
                                    type="text"
                                    required
                                />
                            </div>
                        </Col>
                        <Col sm={12} md={6}>
                            <div className="mb-3">
                                <AvField
                                    name="gracePeriodAmount"
                                    label="Grace Period Amount"
                                    className="form-control"
                                    placeholder="Enter Grace Period Amount"
                                    type="number"
                                    required
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="mb-3">
                        <AvField
                            name="gracePeriodPaymentDate"
                            label="Choose Grace Period Payment Date"
                            className="form-control"
                            type="date"
                            required
                        />
                    </div>
                    <CustomBtn Pending={pending} btnName="Submit" />
                </AvForm>

            </Row>
        </div>
    )
}

export default MandateModal